export default __webpack_public_path__ + "static/media/figuremap15.5586a0e4.png";